import { Suspense } from 'react'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/docs'
)({
  component: RouteComponent,
  beforeLoad: async ({ params }) => {
    // Try to get workspace from localStorage cache first
    let workspaceType: string | undefined

    try {
      const storedWorkspace = localStorage.getItem('auth:activeWorkspace')
      if (storedWorkspace) {
        const workspace = JSON.parse(storedWorkspace)
        // Only use cached data if it's for the same workspace
        if (workspace?.id === params.workspaceId) {
          workspaceType = workspace.type
        }
      }
    } catch (error) {
      console.error('Error reading cached workspace:', error)
    }

    // If not in cache or different workspace, fetch it
    if (!workspaceType) {
      const { trpcClient } = await import('@/lib/trpc')
      const workspace = await trpcClient.workspaces.getWorkspaceById.query({
        id: params.workspaceId
      })
      workspaceType = workspace?.type
    }

    // Block COMPLIANCE workspaces from accessing /docs - redirect to /tasks
    if (workspaceType === 'COMPLIANCE') {
      throw redirect({
        to: '/workspaces/$workspaceId/tasks',
        params: { workspaceId: params.workspaceId },
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  return (
    <Suspense
      fallback={
        <div className='flex h-screen w-screen items-center justify-center'>
          <Loader2 className='h-4 w-4 animate-spin' />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  )
}
